import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, StarIcon, PlayCircleIcon, ShoppingCartIcon, ChevronRightIcon } from 'lucide-react';
export function ArtikelProbleemgedragAdv4Page() {
  const ctaHref = '/webinar-mc-adv4-pmax';
  const trustboxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if ((window as any).Trustpilot && trustboxRef.current) {
      ;
      (window as any).Trustpilot.loadFromElement(trustboxRef.current, true);
    }
  }, []);
  const CtaButton = ({
    children,
    className = ''
  }: {
    children: React.ReactNode;
    className?: string;
  }) => <Link to={ctaHref} className={`inline-block bg-green-600 hover:bg-green-700 text-white text-center font-semibold py-4 px-8 rounded-md shadow-sm transition-colors ${className}`} data-id="element-860">
      {children}
    </Link>;
  return <div className="min-h-screen bg-white text-gray-900" style={{
    fontFamily: "'League Spartan', sans-serif"
  }} data-id="element-861">
      {/* Top navy banner */}
      <div className="bg-blue-900 text-white text-center py-3 text-sm font-medium tracking-wide" data-id="element-862">
        Stressless Dogs — Online Magazine
      </div>

      <div className="max-w-6xl mx-auto px-4 py-8 lg:py-10 pb-32" data-id="element-863">
        {/* Trustpilot row */}
        <div className="flex justify-center mb-6" data-id="element-864">
          <div ref={trustboxRef} className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-theme="light" data-id="element-865">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-866">
              Trustpilot
            </a>
          </div>
        </div>

        <div className="lg:grid lg:grid-cols-3 lg:gap-10" data-id="element-867">
          <article className="lg:col-span-2" data-id="element-868">
            {/* Breadcrumb */}
            <nav className="text-sm text-gray-500 mb-4 flex items-center gap-1" data-id="element-869">
              <span className="font-semibold text-gray-700" data-id="element-870">Home</span>
              <ChevronRightIcon className="w-3 h-3" data-id="element-871" />
              <span className="font-semibold text-gray-700" data-id="element-872">Trending</span>
              <ChevronRightIcon className="w-3 h-3" data-id="element-873" />
              <span data-id="element-874">Hondengedrag</span>
            </nav>

            {/* H1 - NEW */}
            <h1 className="text-3xl lg:text-4xl font-bold leading-tight mb-6" data-id="element-875">
              Trekt, blaft, valt uit of negeert jouw hond je? Dit is waarom - en
              het ligt níet aan jou of je hond.
            </h1>

            {/* Subhead intro */}
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-876">
              Uit onderzoek van <strong data-id="element-877">The Kennel Club (2023)</strong> blijkt
              dat <strong data-id="element-878">72% van de baasjes</strong> denkt dat ze hun hond
              begrijpen - maar dagelijks de signalen missen waardoor honden niet
              luisteren. Een Nederlandse gedragsdeskundige legt in een gratis
              online presentatie uit hoe dit komt. Inmiddels volgden ruim{' '}
              <strong data-id="element-879">100.000 hondenbaasjes</strong> deze presentatie.
            </p>

            {/* Hero figure with new caption */}
            <figure className="mb-8" data-id="element-880">
              <img src="https://cdn.magicpatterns.com/uploads/gR1w9mRJsxnwyNjgpVBF3o/Scherm­afbeelding_2026-05-11_om_11.53.23.png" alt="Hond blaft in huis terwijl eigenaar gefrustreerd toekijkt" className="w-full rounded-sm" data-id="element-881" />
              <figcaption className="bg-gray-100 px-4 py-3 text-sm italic border-l-4 border-gray-300" data-id="element-882">
                <strong data-id="element-883">Notitie van de redactie:</strong> Na het lezen van dit
                artikel snap je waarom traditionele trainingsmethodes vaak
                averechts werken - en wat wél werkt.
              </figcaption>
            </figure>

            {/* NEW BODY */}
            <div className="space-y-5 text-[17px] leading-relaxed text-gray-800" data-id="element-884">
              <h2 className="text-2xl font-bold mt-8 mb-3" data-id="element-885">Herken je dit?</h2>

              <p data-id="element-886">
                Je hond blaft om niks. Trekt je voort tijdens de wandeling. Valt
                uit naar elke hond die voorbijkomt. Springt op tegen bezoek. En
                als je iets zegt, lijkt het alsof hij je niet hoort.
              </p>

              <p data-id="element-887">
                Het frustreert je. Je schaamt je soms zelfs een beetje. En het
                ergste? Je hebt het gevoel dat je iets verkeerd doet als baasje
                - terwijl je gewoon heel veel van je hond houdt.
              </p>

              <p data-id="element-888">
                Maar wat als het probleem helemaal niet bij jou ligt? En ook
                niet bij je hond?
              </p>

              <p data-id="element-889">
                Het echte probleem is dat jullie twee verschillende talen
                spreken. En niemand heeft je ooit geleerd hoe je de zijne moet
                spreken.
              </p>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-890">
                Het echte probleem: jullie spreken een andere taal
              </h2>

              <p data-id="element-891">
                Honden communiceren voor <strong data-id="element-892">95%</strong> met hun lichaam.
                Maar 5% van wat ze "zeggen" gaat via geluid. Voor mensen is dat
                precies andersom - wij praten vooral met woorden.
              </p>

              <p data-id="element-893">
                Het gevolg? Jij zegt met je mond "stop", maar je hond ziet met
                zijn ogen iets heel anders.
              </p>

              <p data-id="element-894">
                Een voorbeeld. Je hond springt op tegen bezoek. Jij reageert
                geïrriteerd: je duwt hem weg, roept "Laag!" of "Nee!" en denkt:
                zo leert hij wel dat het niet mag.
              </p>

              <p data-id="element-895">
                Maar voor een opgewonden hond is fysiek contact - zelfs wegduwen
                - een vorm van aandacht. Net als jouw stemgebruik. Hij denkt
                niet "ik word gestraft." Hij denkt: "Kijk, als ik spring, doet
                mijn baasje mee." En dus springt hij de volgende keer wéér.
              </p>

              <p data-id="element-896">
                Dit soort miscommunicaties gebeuren de hele dag door. Bij
                iedereen. Zonder dat baasjes het doorhebben.
              </p>

              <p data-id="element-897">
                En dit is de kernreden waarom je hond niet luistert. Niet omdat
                hij koppig is. Niet omdat hij je negeert. Maar omdat hij oprecht
                niet begrijpt wat je van hem wilt.
              </p>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-898">
                De verborgen schade: chronische stress bij je hond
              </h2>

              <p data-id="element-899">Dit gaat verder dan alleen ongehoorzaamheid.</p>

              <p data-id="element-900">
                Wanneer je hond keer op keer voelt dat je boos of gefrustreerd
                bent, maar niet snapt waarom - dan bouwt er stress op. Eerst
                klein. Dan dagelijks. En op een gegeven moment chronisch.
              </p>

              <p data-id="element-901">
                Een gestreste hond gaat vaker blaffen. Wordt sneller angstig.
                Valt eerder uit. Soms ontstaan er zelfs lichamelijke klachten
                zoals jeuk, slechte spijsvertering of overmatig haren verliezen.
              </p>

              <p data-id="element-902">
                Dus het gedrag dat jou frustreert? Dat is vaak een symptoom van
                iets dieper liggends. En de oplossing is niet strenger zijn. De
                oplossing is leren communiceren in een taal die je hond wél
                begrijpt.
              </p>

              <p data-id="element-903">
                <strong data-id="element-904">
                  Het ligt niet aan jou. Niemand heeft je dit ooit geleerd.
                </strong>
              </p>

              <figure className="my-6" data-id="element-905">
                <img src="https://cdn.magicpatterns.com/uploads/64fjzy18K6oPyFW36hTnVW/Scherm­afbeelding_2026-05-11_om_12.39.25.png" alt="Eigenaar staat gefrustreerd tegenover hond in woonkamer" className="w-full rounded-sm" data-id="element-906" />
              </figure>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-907">
                Waarom de "alfa-mythe" je hond juist meer stress geeft
              </h2>

              <p data-id="element-908">
                Decennialang werd ons verteld dat we de "alfa" moesten zijn.
                Dominant. De baas. We moesten onze hond corrigeren, op zijn zij
                rollen, hem laten zien wie de leider is.
              </p>

              <p data-id="element-909">Maar deze theorie is allang weerlegd.</p>

              <p data-id="element-910">
                <strong data-id="element-911">Dr. David L. Mech</strong> - de onderzoeker wiens werk
                in de jaren '70 aan de basis stond van het alfa-concept - heeft
                zélf publiekelijk afstand genomen van deze theorie. Zijn
                oorspronkelijke onderzoek werd gedaan op wolven in
                gevangenschap, in onnatuurlijke omstandigheden. In het wild
                blijken wolven helemaal niet in dominantiehiërarchieën te leven.
                Ze leven als familie.
              </p>

              <p data-id="element-912">
                En een Brits onderzoek (<em data-id="element-913">Casey et al., 2014</em>) toonde aan
                dat honden die met dominantie-gebaseerde methodes werden
                getraind, juist <strong data-id="element-914">méér</strong> gedragsproblemen
                ontwikkelden - niet minder.
              </p>

              <p data-id="element-915">
                Toch werken veel hondenscholen en trainers nog steeds met deze
                achterhaalde aanpak. Met als gevolg: gefrustreerde baasjes,
                gestreste honden, en problemen die alleen maar erger worden.
              </p>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-916">
                Maak kennis met Amee de Bruijn
              </h2>

              <p data-id="element-917">
                Gedragsdeskundige <strong data-id="element-918">Amee de Bruijn</strong>, oprichtster
                van Stressless Dogs, koos een fundamenteel andere weg.
              </p>

              <p data-id="element-919">
                In plaats van honden te dwingen in een mensenwereld te leven,
                ontwikkelde ze een methode waarbij mensen leren hoe honden
                onderling met elkaar praten. Welke subtiele signalen ze
                gebruiken. Wat een schuine kop, een likje aan de lippen of een
                halve oogopslag werkelijk betekent.
              </p>

              <p className="italic text-gray-700 border-l-4 border-gray-200 pl-4" data-id="element-920">
                "Het is als gebarentaal leren," legt Amee uit. "Je leert wat
                honden je de hele dag al proberen te vertellen - je hebt het
                alleen nog niet kunnen lezen."
              </p>

              <p data-id="element-921">
                Haar aanpak is inmiddels gevolgd door meer dan{' '}
                <strong data-id="element-922">100.000 hondenbaasjes</strong> via haar gratis online
                presentatie. Ze hielp persoonlijk al ruim 15.000 baasjes en hun
                honden. En op Trustpilot staan inmiddels meer dan{' '}
                <strong data-id="element-923">1.000 5-sterren reviews</strong>.
              </p>

              <figure className="my-6" data-id="element-924">
                <img src="https://cdn.magicpatterns.com/uploads/wcMLW1G1v4odnWZoLhJJwj/Scherm­afbeelding_2026-05-11_om_13.20.43.png" alt="Amee legt hondencommunicatie uit op een whiteboard" className="w-full rounded-sm" data-id="element-925" />
              </figure>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-926">
                Wat je in de gratis online presentatie leert
              </h2>

              <p data-id="element-927">
                In 90 minuten neemt Amee je mee door wat je hond je probeert te
                vertellen. Concreet leer je:
              </p>

              <ul className="space-y-3" data-id="element-928">
                {[<>
                    <strong data-id="element-929">De 5 basis-signalen</strong> die elke hond gebruikt
                    - en wat ze écht betekenen
                  </>, <>
                    <strong data-id="element-930">Hoe je stress herkent</strong> vóórdat het escaleert
                    tot blaffen, trekken of uitvallen
                  </>, <>
                    <strong data-id="element-931">De 3 grootste misverstanden</strong> die dagelijks
                    tot frustratie leiden bij honden en baasjes
                  </>, <>
                    <strong data-id="element-932">Direct toepasbare technieken</strong> om terug te
                    communiceren in zijn taal - zonder commando's, zonder
                    snoepjes, zonder corrigeren
                  </>].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-933">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-600 text-white flex items-center justify-center mt-0.5" data-id="element-934">
                      <CheckIcon className="w-4 h-4" data-id="element-935" />
                    </span>
                    <span data-id="element-936">{item}</span>
                  </li>)}
              </ul>

              <p className="italic text-gray-700 border-l-4 border-gray-200 pl-4 mt-6" data-id="element-937">
                "Wat ik baasjes zie ervaren in dat ene webinar," vertelt Amee,
                "is dat alles op zijn plaats valt. Ineens snap je waarom je hond
                doet wat hij doet."
              </p>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-938">
                Hoe Linda's hond Bella weer rust vond
              </h2>

              <p data-id="element-939">
                <strong data-id="element-940">Linda (47) uit Utrecht</strong> had het bijna opgegeven
                met haar Bella, een Border Collie van vier.
              </p>

              <p data-id="element-941">
                Bella viel uit naar elke hond op straat. Bezoek ontvangen was
                onmogelijk geworden - ze blafte zichzelf bijna een
                hartstilstand. Linda had drie hondenscholen geprobeerd en zelfs
                een privé-trainer ingehuurd die met correctie-halsbanden werkte.
                Het werd alleen maar erger.
              </p>

              <p className="italic text-gray-700 border-l-4 border-gray-200 pl-4" data-id="element-942">
                "Ik was zó moe," zegt Linda. "Ik durfde nauwelijks meer de deur
                uit met haar."
              </p>

              <p data-id="element-943">
                Toen vond ze de gratis online presentatie van Amee. Het eerste
                wat ze zich realiseerde: alle correcties hadden Bella's stress
                alleen maar opgebouwd. De hond die ze "agressief" noemde, was
                eigenlijk doodsbang.
              </p>

              <figure className="my-6" data-id="element-944">
                <img src="https://cdn.magicpatterns.com/uploads/tEawgTwN6ANqek5vk3uxJE/Scherm­afbeelding_2026-05-11_om_12.41.32.png" alt="700+ vijf-sterren reviews voor Amee van Stressless Dogs op Trustpilot" className="w-full rounded-sm" data-id="element-945" />
              </figure>

              <p data-id="element-946">
                Binnen twee weken merkte Linda subtiele veranderingen. Bella
                ging op de bank liggen in plaats van bij elk geluid op te
                springen. Na drie weken kon Linda voor het eerst in maanden een
                rustige wandeling maken - zónder dat Bella explodeerde bij de
                eerste hond die voorbijkwam.
              </p>

              <p className="italic text-gray-700 border-l-4 border-gray-200 pl-4" data-id="element-947">
                "Ze is nog steeds dezelfde hond," zegt Linda. "Maar ik begrijp
                haar nu en zij begrijpt mij. Daardoor wordt alles makkelijker."
              </p>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-948">
                Wat andere baasjes zeggen
              </h2>

              <div className="space-y-4" data-id="element-949">
                <div className="bg-gray-50 rounded-lg p-5" data-id="element-950">
                  <div className="flex gap-0.5 mb-2" data-id="element-951">
                    {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-952" />)}
                  </div>
                  <p className="italic text-gray-700 mb-2" data-id="element-953">
                    "Ik had al veel hondentrainingen gevolgd en certificaten
                    gehaald, maar toch kreeg mijn hond gedragsproblemen, zoals
                    uitvallen en niet goed luisteren. Dat frustreerde me, want
                    ik wist niet goed wat ik verkeerd deed. Ik ben begonnen met
                    'Liefdevol communiceren met je hond' en die heeft écht een
                    verschil gemaakt. Ik begrijp nu veel beter wat mijn hond wél
                    en niet snapt."
                  </p>
                  <p className="text-sm font-semibold" data-id="element-954">— R. Bosma</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-5" data-id="element-955">
                  <div className="flex gap-0.5 mb-2" data-id="element-956">
                    {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-957" />)}
                  </div>
                  <p className="italic text-gray-700 mb-2" data-id="element-958">
                    "De cursus is een echte eye opener. Door hem te volgen en
                    toe te passen krijg ik een veel betere band met mijn honden
                    en ga ik ze écht begrijpen. Dank je wel."
                  </p>
                  <p className="text-sm font-semibold" data-id="element-959">— Annemiek De Buyst</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-5" data-id="element-960">
                  <div className="flex gap-0.5 mb-2" data-id="element-961">
                    {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-962" />)}
                  </div>
                  <p className="italic text-gray-700 mb-2" data-id="element-963">
                    "Mijn hond is met de 5 meter lijn in een maand veranderd van
                    trek-neuroot tot super lieve en volgzame hond."
                  </p>
                  <p className="text-sm font-semibold" data-id="element-964">— P. Abeln</p>
                </div>
              </div>

              <p className="text-sm text-gray-600 italic" data-id="element-965">
                Dit is een greep uit meer dan 1.000 5-sterren reviews op
                Trustpilot.
              </p>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-966">
                Hoe je je gratis kunt aanmelden
              </h2>

              <p data-id="element-967">
                Aanmelden gaat via de groene knop hieronder. Je komt op een
                aanmeldpagina waar je je naam en e-mailadres invult en een datum
                kiest die jou uitkomt.
              </p>

              <p data-id="element-968">
                Op het juiste tijdstip ontvang je een link in je inbox. Daarmee
                kun je live deelnemen - ondertussen kun je via de chat vragen
                stellen.
              </p>

              <p data-id="element-969">
                <strong data-id="element-970">Belangrijk:</strong> per sessie zijn er maar{' '}
                <strong data-id="element-971">75 plekken</strong> beschikbaar. Amee wil de kwaliteit
                hoog houden en alle deelnemers ruimte geven voor vragen. Vol =
                vol, maar er staan meerdere sessies gepland.
              </p>

              <p data-id="element-972">
                Mocht je live niet kunnen, geen zorgen - alle deelnemers krijgen
                achteraf automatisch de opname toegestuurd, zodat je het op je
                eigen moment terug kunt kijken.
              </p>

              <div className="my-8 flex justify-center" data-id="element-973">
                <CtaButton className="w-full sm:w-auto" data-id="element-974">
                  Bekijk beschikbaarheid online presentatie →
                </CtaButton>
              </div>

              <p className="text-center text-gray-700" data-id="element-975">
                De eerstvolgende sessies vullen meestal binnen een paar dagen.
                Kies een datum die past en reserveer je plek nu het nog gratis
                is.
              </p>
            </div>

            {/* ===== BOTTOM SECTION (existing content) ===== */}
            <figure className="mt-12 mb-8" data-id="element-976">
              <img src="https://cdn.magicpatterns.com/uploads/5UKJd2JMm3eRmUZoqemDAo/Scherm­afbeelding_2026-05-11_om_15.05.42.png" alt="Testimonial: 'Toen ik toepaste op mijn hond wat Amee me leerde zag ik meteen dat mijn hond totaal anders reageerde op me.'" className="w-full rounded-sm" data-id="element-977" />
            </figure>

            <h2 className="text-3xl lg:text-4xl font-bold leading-tight mb-8" data-id="element-978">
              Hoe werkt de online presentatie van Amee?
            </h2>

            <div className="space-y-5 text-[17px] leading-relaxed text-gray-800" data-id="element-979">
              <p data-id="element-980">
                Na met duizenden baasjes gewerkt te hebben zegt Amee: 'De online
                presentatie 'Communiceren met je hond' is de allerbeste manier
                om hondenouders alles te leren over hondencommunicatie. Ik kan
                alles vertellen wat ik wil, videobeelden laten zien en tegelijk
                vragen beantwoorden.{' '}
                <strong data-id="element-981">
                  Vroeger betaalden mensen soms duizenden euro's voor mijn hulp,
                  maar via deze online presentatie biedt ik het nu tijdelijk
                  gratis aan.
                </strong>
                '
              </p>

              <p data-id="element-982">
                En als je als deelnemer van de online presentatie tot het einde
                blijft krijg je ook nog eens een verrassingscadeau (iets waar de
                meeste baasjes normaal voor betalen)!
              </p>

              <figure className="my-6" data-id="element-983">
                <img src="https://cdn.magicpatterns.com/uploads/6bpYxWvVYNk8oNWps9nsR5/Scherm­afbeelding_2026-05-11_om_15.07.15.png" alt="Webinar preview met Amee en chat" className="w-full rounded-sm" data-id="element-984" />
              </figure>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-985">
                Aanmelden kan via de groene knoppen op deze pagina.
              </h2>

              <p data-id="element-986">
                Vervolgens kom je op een aanmeldpagina, daar kan je zien of er
                nog online presentaties staan gepland en of er beschikbaarheid
                is. Daar vul je jouw naam en emailadres in en kies je een datum
                en tijd.
              </p>

              <p data-id="element-987">
                Na aanmelding krijg je een bevestigingsmail met een link. Op het
                juiste tijdstip kan je via deze link deelnemen aan de online
                presentatie. Samen met anderen kom je in een wachtruimte waarna
                de presentatie zal starten.{' '}
                <strong data-id="element-988">Dit wordt ook een webinar genoemd.</strong> Via de
                chatfunctie kan je ondertussen vragen stellen.
              </p>

              <p data-id="element-989">
                Er zijn{' '}
                <strong data-id="element-990">per online presentatie slechts 75 plekken</strong> en
                Amee weet niet of het na vandaag nog mogelijk is om mee te doen.
              </p>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-991">
                Je kunt de online presentatie op je eigen gemak en in je eigen
                tijd bekijken!
              </h2>

              <div className="my-6 rounded-lg overflow-hidden" data-id="element-992">
                <img src="https://cdn.magicpatterns.com/uploads/2HVuaSn7zFpqwwzDhsSfTo/Scherm­afbeelding_2026-05-11_om_13.21.43.png" alt="Vrouw traint rustig haar hond in het park" className="w-full h-auto" data-id="element-993" />
              </div>

              <p data-id="element-994">
                Om er zeker van te zijn dat iedereen die zich aanmeldt de kans
                krijgt alles te zien, krijgt iedereen de opname toegestuurd naar
                zijn of haar e-mailadres.
              </p>

              <h2 className="text-2xl font-bold mt-10 mb-3" data-id="element-995">
                De informatie uit deze online presentatie vind je nergens
                anders...
              </h2>

              <p data-id="element-996">
                Traditionele trainingsmethoden focussen op het veranderen van
                hondengedrag. Maar Amee's benadering is totaal anders.
              </p>

              <p className="italic text-gray-700 border-l-4 border-gray-200 pl-4" data-id="element-997">
                'Het is als het leren van gebarentaal,' legt ze uit. 'Je leert
                hoe honden onderling elkaar subtiele signalen geven met hun
                lichaam. Aan deze signalen kan je zien wat ze voelen en willen.
                Ook leer je hoe je als mens deze signalen kan gebruiken zodat je
                jouw hond dingen kan vertellen in zijn taal.'
              </p>

              <h3 className="text-xl font-bold mt-8 mb-3" data-id="element-998">
                Tijdens deze online presentatie ontdek je:
              </h3>

              <ul className="space-y-3" data-id="element-999">
                {[<>
                    <strong data-id="element-1000">De vijf basis-signalen</strong> die elke hond
                    gebruikt en wat ze betekenen
                  </>, <>
                    <strong data-id="element-1001">Hoe je stress herkent</strong> voordat het escaleert
                    naar probleemgedrag
                  </>, <>
                    <strong data-id="element-1002">De drie grootste misverstanden</strong> die leiden
                    tot frustratie bij beide partijen
                  </>, <>
                    <strong data-id="element-1003">Direct toepasbare technieken</strong> om terug te
                    communiceren in zijn taal
                  </>].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1004">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-green-600 text-white flex items-center justify-center mt-0.5" data-id="element-1005">
                      <CheckIcon className="w-4 h-4" data-id="element-1006" />
                    </span>
                    <span data-id="element-1007">{item}</span>
                  </li>)}
              </ul>

              <p className="italic text-gray-700 border-l-4 border-gray-200 pl-4 mt-6" data-id="element-1008">
                'Ik begin met de signalen die mensen het meest herkennen, maar
                verkeerd interpreteren,' legt ze uit. '
                <strong data-id="element-1009">
                  Zodra ze doorhebben dat veel van het dominante gedrag
                  eigenlijk heel iets anders betekent, valt alles op zijn
                  plaats. Dan zijn de overige signalen logische uitbreidingen.
                </strong>
                '
              </p>

              <p data-id="element-1010">
                'Veel mensen vragen zich af of ze online wel iets over hun hond
                kunnen leren,' grapt Amee. 'Maar omdat hondentaal voor alle
                honden hetzelfde is kan ik je met voorbeeld video's en een goede
                presentatie al super veel leren over je eigen hond.'
              </p>

              <p data-id="element-1011">
                'Honden zijn geen mysterieuze wezens,' zegt Amee. '
                <strong data-id="element-1012">
                  Hondentaal is subtiel, maar glashelder. Ze communiceren helder
                  en consistent. Je moet alleen leren waar je naar moet kijken.
                </strong>
                '
              </p>

              <p data-id="element-1013">
                Na deze online presentatie{' '}
                <strong data-id="element-1014">
                  kiezen veel baasjes om zelfs te stoppen met hun
                  gedragsdeskundige of hondenschool
                </strong>{' '}
                omdat ze hier meer leren.
              </p>

              <p data-id="element-1015">
                Meld je nu aan voor de online presentatie nu het nog gratis is,
                klik op de groene knop hieronder, ga naar de volgende pagina,
                kies een geschikte datum en tijd die voor jou past.
              </p>

              <div className="my-8 flex justify-center" data-id="element-1016">
                <CtaButton className="w-full sm:w-auto" data-id="element-1017">
                  Bekijk beschikbaarheid online presentatie
                </CtaButton>
              </div>

              <h2 className="text-2xl font-bold mt-4 mb-4" data-id="element-1018">
                Klik op de knop hierboven om een plek te reserveren voor deze
                tijdelijke gratis online presentatie Communiceren met je hond!
              </h2>

              {/* Update notice */}
              <div className="border-2 border-red-500 bg-gray-50 rounded-lg p-6 my-6" data-id="element-1019">
                <p className="mb-4" data-id="element-1020">
                  <span className="text-red-600 font-bold" data-id="element-1021">Update:</span>{' '}
                  <strong data-id="element-1022">11 mei, 2026</strong>: Gezien de drukte in zowel haar
                  prive leven, moeten we helaas mede delen{' '}
                  <strong data-id="element-1023">
                    dat Amee niet weet of het webinar na deze week nog gevolgd
                    kan worden.
                  </strong>
                </p>
                <p className="mb-4" data-id="element-1024">
                  Het webinar is momenteel razend populair. Daarom kunnen we ook
                  niet garanderen dat er nog plekken zijn voor deze week omdat
                  er maximaal 75 hondenouders kunnen meedoen.
                </p>
                <p data-id="element-1025">
                  Je kan via onderstaande knop controleren of er nog plekken
                  zijn voor vandaag of morgen.
                </p>
              </div>

              <div className="my-8 flex justify-center" data-id="element-1026">
                <CtaButton className="w-full sm:w-auto" data-id="element-1027">
                  Bekijk beschikbaarheid online presentatie
                </CtaButton>
              </div>

              {/* Final highlighted card */}
              <div className="bg-white border border-gray-200 rounded-xl shadow-md p-6 lg:p-8 my-10" data-id="element-1028">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center" data-id="element-1029">
                  <div data-id="element-1030">
                    <img src="https://cdn.magicpatterns.com/uploads/3MGrhTCPbm4BnVirrPnY5K/Scherm­afbeelding_2026-05-11_om_15.04.47.png" alt="Online presentatie preview met Amee" className="w-full rounded-lg" data-id="element-1031" />
                  </div>

                  <div className="text-center" data-id="element-1032">
                    <p className="text-base mb-4" data-id="element-1033">
                      VANDAAG EN MORGEN IS{' '}
                      <strong data-id="element-1034">DEELNAME AAN ONLINE PRESENTATIE GRATIS</strong> EN
                      KRIJG JE <strong data-id="element-1035">€30 AAN VERRASSINGS CADEAUS</strong>
                    </p>
                    <p className="text-sm text-gray-600 mb-5" data-id="element-1036">
                      Deze gratis online presentatie is razend populair en de
                      plekken raken snel vol.
                    </p>
                    <Link to={ctaHref} className="block w-full bg-green-600 hover:bg-green-700 text-white text-center font-bold py-4 px-6 rounded-full shadow-sm transition-colors mb-4" data-id="element-1037">
                      ✓ BEKIJK BESCHIKBAARHEID
                    </Link>
                    <div className="grid grid-cols-2 gap-2 text-xs" data-id="element-1038">
                      <div className="bg-yellow-50 py-2 px-3 rounded" data-id="element-1039">
                        LET OP:{' '}
                        <span className="text-red-600 font-bold" data-id="element-1040">
                          14 plekken
                        </span>
                      </div>
                      <div className="bg-yellow-50 py-2 px-3 rounded flex items-center justify-center gap-1" data-id="element-1041">
                        <ShoppingCartIcon className="w-3 h-3" data-id="element-1042" /> GRATIS deelname
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>

          {/* Sticky sidebar */}
          <aside className="hidden lg:block lg:col-span-1" data-id="element-1043">
            <div className="sticky top-6 bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-1044">
              <p className="text-center font-bold text-lg mb-2" data-id="element-1045">Aanrader:</p>
              <div className="flex justify-center gap-0.5 mb-2" data-id="element-1046">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-1047" />)}
              </div>
              <p className="text-center text-sm text-gray-600 mb-5" data-id="element-1048">
                <strong data-id="element-1049">4.68</strong> | 1000+ Geverifieerde Reviews
              </p>

              <h3 className="font-bold text-lg leading-tight mb-4 text-center" data-id="element-1050">
                Gratis Online Presentatie: Communiceren met je hond
              </h3>

              <ul className="space-y-3 mb-5" data-id="element-1051">
                {['Waarom je hond blaft, trekt, uitvalt, opspringt of angstig is', 'Wat de nieuwste wetenschap zegt over hondentraining (meeste baasjes weten dit niet)', 'Hoe je gedragsproblemen oplost, zonder straffen of corrigeren', "Hoe je de 'Verborgen Handleiding' van je hond vindt en zo beter samenwerkt dan ooit"].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-1052">
                    <span className="flex-shrink-0 w-5 h-5 rounded-full bg-green-600 text-white flex items-center justify-center mt-0.5" data-id="element-1053">
                      <CheckIcon className="w-3 h-3" data-id="element-1054" />
                    </span>
                    <span data-id="element-1055">{item}</span>
                  </li>)}
              </ul>

              <p className="text-sm text-center mb-4" data-id="element-1056">
                Vandaag om <strong data-id="element-1057">10:00</strong>, <strong data-id="element-1058">13:00</strong> of{' '}
                <strong data-id="element-1059">20:00</strong>
              </p>

              <div className="rounded-lg overflow-hidden mb-4 aspect-video bg-gray-100" data-id="element-1060">
                <img src="https://cdn.magicpatterns.com/uploads/o5oXcxyFnv65igmDcbYHEc/Scherm­afbeelding_2026-05-11_om_11.52.59.png" alt="Webinar preview" className="w-full h-full object-cover" data-id="element-1061" />
              </div>

              <Link to={ctaHref} className="block w-full bg-green-600 hover:bg-green-700 text-white text-center font-bold py-3 px-6 rounded-full shadow-sm transition-colors" data-id="element-1062">
                Aanmelden
              </Link>
            </div>
          </aside>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-blue-900 text-white py-12 px-4" data-id="element-1063">
        <div className="max-w-4xl mx-auto text-sm leading-relaxed text-center space-y-6" data-id="element-1064">
          <p data-id="element-1065">
            Meta Advertising Disclaimer: Deze website maakt gebruik van Meta
            Pixel voor advertentiedoeleinden. Dit betekent dat informatie over
            uw bezoek aan deze website wordt gedeeld met Meta (Facebook) om
            gerichte advertenties te kunnen tonen. Door gebruik te maken van
            deze website gaat u akkoord met het gebruik van cookies en
            vergelijkbare technologieën voor analytische en
            advertentiedoeleinden. Deze pagina is een advertorial voor
            Stressless Dogs. Stressless Dogs is een onafhankelijk bedrijf en is
            op geen enkele wijze verbonden aan of onderdeel van Meta (voorheen
            Facebook). Deze advertentie wordt getoond via het Meta
            advertentieplatform, maar Meta is niet verantwoordelijk voor de
            inhoud of diensten aangeboden door Stressless Dogs.
          </p>
          <div className="border-t border-blue-800 pt-6" data-id="element-1066">
            <p className="text-xs tracking-wide" data-id="element-1067">
              THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
              CONSUMER PROTECTION UPDATE
            </p>
          </div>
        </div>
      </footer>

      {/* Sticky bottom bar */}
      <Link to={ctaHref} className="fixed bottom-0 left-0 right-0 bg-green-600 hover:bg-green-700 text-white z-50 shadow-lg transition-colors" data-id="element-1068">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-center gap-4" data-id="element-1069">
          <span className="font-semibold text-sm sm:text-base" data-id="element-1070">
            Online Presentatie: Communiceren Met Je Hond
          </span>
          <span className="bg-white text-green-700 font-bold px-4 py-2 rounded-full text-sm whitespace-nowrap" data-id="element-1071">
            Gratis Aanmelden →
          </span>
        </div>
      </Link>
    </div>;
}